import { theme } from "../../../theme/theme";
const style = () => {
    const { colorBgPrimary, space4 } = theme();
    return {
        bullets: {
            alignItems: "center",
            flexDirection: "row",
            justifyContent: "center",
            paddingVertical: space4,
        },
        item: {
            marginHorizontal: 3,
            backgroundColor: colorBgPrimary,
        },
        colorBgPrimary,
    };
};
export { style };
